import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'
import { Container, Row, Col } from 'reactstrap'

const ArticlesWrapper = styled.div`
  padding-top: 60px;
  padding-bottom: 60px;
  @media (max-width: 575px) {
    padding-bottom: 10px;
  }
`

const ArticlesContainer = styled(Container)`
  padding-left: 25px;
  padding-right: 25px;
  @media (max-width: 575px) {
    padding-left: 10px;
    padding-right: 10px;
  }
`

const ArticlesTitleWrapper = styled(Col)`
  margin-bottom: 15px;
`

export const ArticlesTitle = styled.h2`
  color: ${(props) => props.theme.colorBlack};
  font-family: ${(props) => props.theme.fontBNPPSansCondensed};
  font-size: 40px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  line-height: 1;
  margin-bottom: 40px;
  span {
    position: relative;
    padding-bottom: 10px;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      display: block;
      height: 4px;
      background-color: #5dc66a;
    }
  }
`

const ArticlesItemWrapper = styled(Col)`
  position: relative;
  padding-left: 5px;
  padding-right: 5px;
  margin-bottom: 10px;
  .articlesImage {
    @media (max-width: 575px) {
      display: none;
    }
  }
  .articlesImageMobile {
    display: none;
    @media (max-width: 575px) {
      display: block;
    }
  }
`

const ArticlesItemInnerWrapper = styled.div`
  position: absolute;
  top: 20px;
  left: 5px;
  right: 5px;
  bottom: 0;
  color: ${(props) => props.theme.colorWhite};
  line-height: 1.2;
  padding-left: 30px;
  @media (min-width: 992px) and (max-width: 1199px) {
    padding-left: 20px;
  }
  @media (max-width: 767px) {
    padding-left: 15px;
  }
  @media (max-width: 575px) {
    padding-left: 20px;
  }
  .person {
    position: relative;
    font-size: 12px;
    @media (max-width: 575px) {
      font-size: 10px;
    }
    &:before {
      content: '';
      position: absolute;
      left: -30px;
      bottom: -8px;
      display: block;
      width: 110px;
      height: 1px;
      background-color: ${(props) => props.theme.colorWhite};
      @media (max-width: 575px) {
        left: 0;
        width: 110px;
        height: 2px;
      }
    }
  }
  .title {
    margin-top: 25px;
    @media (max-width: 575px) {
      font-size: 22px !important;
    }
    &.first {
      font-size: 24px;
      margin-top: 0 !important;
      @media (min-width: 992px) and (max-width: 1199px) {
        font-size: 20px;
      }
    }
    &.two {
      font-size: 23px;
      @media (min-width: 992px) and (max-width: 1199px) {
        font-size: 21px;
      }
    }
    &.three {
      font-size: 26px;
      @media (min-width: 992px) and (max-width: 1199px) {
        font-size: 23px;
      }
    }
    &.four,
    &.five {
      font-size: 34px;
      @media (min-width: 992px) and (max-width: 1199px) {
        font-size: 28px;
      }
    }
    &.six,
    &.seven {
      font-size: 23px;
      @media (min-width: 992px) and (max-width: 1199px) {
        font-size: 20px;
      }
    }
    &.eigth,
    &.nine {
      font-size: 23px;
      @media (min-width: 992px) and (max-width: 1199px) {
        font-size: 20px;
      }
    }
    &.ten {
      font-size: 26px;
      @media (min-width: 992px) and (max-width: 1199px) {
        font-size: 23px;
      }
    }
  }
  .desc {
    font-size: 16px;
    font-weight: 300;
    @media (min-width: 992px) and (max-width: 1199px) {
      font-size: 14px;
    }
  }
  .black {
    color: ${(props) => props.theme.colorBlack};
  }
`

const ArticlesLinkButtonWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  @media (max-width: 575px) {
    right: 20px;
  }
`

const ArticlesLinkButton = styled(Link)`
  position: relative;
  display: block;
  background-color: ${(props) => props.theme.colorGreenLight};
  color: ${(props) => props.theme.colorWhite};
  font-family: ${(props) => props.theme.fontBNPPSansCondensed};
  font-size: 24px;
  font-weight: 300;
  text-transform: uppercase;
  text-decoration: none;
  line-height: 1;
  padding-top: 5px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 5px;
  transition: all 0.2s ease;
  &:hover,
  &:focus {
    color: ${(props) => props.theme.colorWhite};
    text-decoration: none;
    &:before {
      right: 8px;
    }
  }
  &:before {
    content: '';
    position: absolute;
    top: 50%;
    right: 10px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-left: 6px solid ${(props) => props.theme.colorWhite};
    border-bottom: 6px solid transparent;
    transform: translateY(-50%);
    transition: all 0.2s ease;
  }
`

const Articles = (props) => {
  const data = useStaticQuery(graphql`
    query {
      ArticlesImage1: file(
        relativePath: { eq: "parent/articles/articles1.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 767) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImage2: file(
        relativePath: { eq: "parent/articles/articles2.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 767) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImage3: file(
        relativePath: { eq: "parent/articles/articles3.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 767) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImage4: file(
        relativePath: { eq: "parent/articles/articles4.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 767) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImage5: file(
        relativePath: { eq: "parent/articles/articles5.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 767) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImage6: file(
        relativePath: { eq: "parent/articles/articles6.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 767) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImage7: file(
        relativePath: { eq: "parent/articles/articles7.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 767) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImage8: file(
        relativePath: { eq: "parent/articles/articles8.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 767) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImage9: file(
        relativePath: { eq: "parent/articles/articles9.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 767) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      ArticlesImageMobile1: file(
        relativePath: { eq: "parent/articles/articles1_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 575) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImageMobile2: file(
        relativePath: { eq: "parent/articles/articles2_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 575) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImageMobile3: file(
        relativePath: { eq: "parent/articles/articles3_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 575) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImageMobile4: file(
        relativePath: { eq: "parent/articles/articles4_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 575) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImageMobile5: file(
        relativePath: { eq: "parent/articles/articles5_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 575) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImageMobile6: file(
        relativePath: { eq: "parent/articles/articles6_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 575) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImageMobile7: file(
        relativePath: { eq: "parent/articles/articles7_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 575) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImageMobile8: file(
        relativePath: { eq: "parent/articles/articles8_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 575) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      ArticlesImageMobile9: file(
        relativePath: { eq: "parent/articles/articles9_mobile.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 575) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  return (
    <ArticlesWrapper id="articles">
      <ArticlesContainer>
        <Row>
          <ArticlesTitleWrapper xs={12}>
            <ArticlesTitle>
              <span>artykuły</span>
            </ArticlesTitle>
          </ArticlesTitleWrapper>
        </Row>
        <Row>
          <Col xs={12} lg={6}>
            <Row>
              <ArticlesItemWrapper xs={12} sm={6}>
                <ArticlesItemInnerWrapper>
                  <p className="title first black">
                    O{'\u00A0'}ważnych tematach piszą dla nas eksperci i
                    {'\u00A0'}edukatorzy.
                  </p>
                  <p className="desc black">
                    Poznaj ich obserwacje, porady i&nbsp;wiedzę, którymi się
                    dzielą.
                  </p>
                </ArticlesItemInnerWrapper>
              </ArticlesItemWrapper>
              <ArticlesItemWrapper xs={12} sm={6}>
                <Img
                  fluid={data.ArticlesImage8.childImageSharp.fluid}
                  className="articlesImage"
                />
                <Img
                  fluid={data.ArticlesImageMobile8.childImageSharp.fluid}
                  className="articlesImageMobile"
                />
                <ArticlesItemInnerWrapper>
                  <p className="person"></p>
                  <p className="title nine">
                    Twoje dziecko myśli,
                    <br />
                    że kieszonkowe spada z{'\u00A0'}nieba?
                    <br />
                    Możesz to zmienić!
                  </p>
                  <ArticlesLinkButtonWrapper>
                    <ArticlesLinkButton to="/strefa-rodzica/twoje-dziecko-mysli-ze-kieszonkowe-spada-z-nieba">
                      czytaj całość
                    </ArticlesLinkButton>
                  </ArticlesLinkButtonWrapper>
                </ArticlesItemInnerWrapper>
              </ArticlesItemWrapper>
              <ArticlesItemWrapper xs={12}>
                <Img
                  fluid={data.ArticlesImage9.childImageSharp.fluid}
                  className="articlesImage"
                />
                <Img
                  fluid={data.ArticlesImageMobile9.childImageSharp.fluid}
                  className="articlesImageMobile"
                />
                <ArticlesItemInnerWrapper>
                  <p className="person"></p>
                  <p className="title ten">
                    Jak ustalić wysokość kieszonkowego?
                  </p>
                  <ArticlesLinkButtonWrapper>
                    <ArticlesLinkButton to="/strefa-rodzica/jak-ustalic-wysokosc-kieszonkowego">
                      czytaj całość
                    </ArticlesLinkButton>
                  </ArticlesLinkButtonWrapper>
                </ArticlesItemInnerWrapper>
              </ArticlesItemWrapper>
            </Row>
          </Col>
          <ArticlesItemWrapper xs={12} lg={6}>
            <Img
              fluid={data.ArticlesImage7.childImageSharp.fluid}
              className="articlesImage"
            />
            <Img
              fluid={data.ArticlesImageMobile7.childImageSharp.fluid}
              className="articlesImageMobile"
            />
            <ArticlesItemInnerWrapper>
              <p className="person"></p>
              <p className="title eigth">
                Czy dawanie kieszonkowego
                <br />
                się opłaca?
              </p>
              <ArticlesLinkButtonWrapper>
                <ArticlesLinkButton to="/strefa-rodzica/czy-dawanie-kieszonkowego-sie-oplaca">
                  czytaj całość
                </ArticlesLinkButton>
              </ArticlesLinkButtonWrapper>
            </ArticlesItemInnerWrapper>
          </ArticlesItemWrapper>
        </Row>
        <Row>
          <ArticlesItemWrapper xs={12} lg={6}>
            <Img
              fluid={data.ArticlesImage4.childImageSharp.fluid}
              className="articlesImage"
            />
            <Img
              fluid={data.ArticlesImageMobile4.childImageSharp.fluid}
              className="articlesImageMobile"
            />
            <ArticlesItemInnerWrapper>
              <p className="person">Aleksandra Belta-Iwac, 16.04.2021</p>
              <p className="title five">
                Mamo kup{'\u00A0'}mi! – jak{'\u00A0'}reagować
                <br /> na{'\u00A0'}dziecięce prośby
              </p>
              <ArticlesLinkButtonWrapper>
                <ArticlesLinkButton to="/strefa-rodzica/mamo-kup-mi-jak-reagowac-na-dzieciece-prosby">
                  czytaj całość
                </ArticlesLinkButton>
              </ArticlesLinkButtonWrapper>
            </ArticlesItemInnerWrapper>
          </ArticlesItemWrapper>
          <Col xs={12} lg={6}>
            <Row>
              <ArticlesItemWrapper xs={12}>
                <Img
                  fluid={data.ArticlesImage5.childImageSharp.fluid}
                  className="articlesImage"
                />
                <Img
                  fluid={data.ArticlesImageMobile5.childImageSharp.fluid}
                  className="articlesImageMobile"
                />
                <ArticlesItemInnerWrapper>
                  <p className="person">Tomasz Jaroszek, 16.04.2021</p>
                  <p className="title six">
                    7{'\u00A0'}stereotypów na{'\u00A0'}temat pieniędzy,
                    <br />
                    z którymi warto rozprawiać
                    <br />
                    się od{'\u00A0'}dziecka
                  </p>
                  <ArticlesLinkButtonWrapper>
                    <ArticlesLinkButton to="/strefa-rodzica/7-stereotypow-na-temat-pieniedzy">
                      czytaj całość
                    </ArticlesLinkButton>
                  </ArticlesLinkButtonWrapper>
                </ArticlesItemInnerWrapper>
              </ArticlesItemWrapper>
              <ArticlesItemWrapper xs={12}>
                <Img
                  fluid={data.ArticlesImage6.childImageSharp.fluid}
                  className="articlesImage"
                />
                <Img
                  fluid={data.ArticlesImageMobile6.childImageSharp.fluid}
                  className="articlesImageMobile"
                />
                <ArticlesItemInnerWrapper>
                  <p className="person">Aleksandra Piotrkowska, 16.04.2021</p>
                  <p className="title seven">
                    Różnice finansowe w{'\u00A0'}klasie &ndash; jak uczyć dzieci
                    <br />
                    szacunku do{'\u00A0'}wszystkich
                  </p>
                  <ArticlesLinkButtonWrapper>
                    <ArticlesLinkButton to="/strefa-rodzica/roznice-finansowe-w-klasie">
                      czytaj całość
                    </ArticlesLinkButton>
                  </ArticlesLinkButtonWrapper>
                </ArticlesItemInnerWrapper>
              </ArticlesItemWrapper>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={6}>
            <Row>
              <ArticlesItemWrapper xs={12}>
                <Img
                  fluid={data.ArticlesImage1.childImageSharp.fluid}
                  className="articlesImage"
                />
                <Img
                  fluid={data.ArticlesImageMobile1.childImageSharp.fluid}
                  className="articlesImageMobile"
                />
                <ArticlesItemInnerWrapper>
                  <p className="person">Grzegorz Kasdepke, 16.04.2021</p>
                  <p className="title two">Tysiak!</p>
                  <ArticlesLinkButtonWrapper>
                    <ArticlesLinkButton to="/strefa-rodzica/tysiak">
                      czytaj całość
                    </ArticlesLinkButton>
                  </ArticlesLinkButtonWrapper>
                </ArticlesItemInnerWrapper>
              </ArticlesItemWrapper>
              <ArticlesItemWrapper xs={12}>
                <Img
                  fluid={data.ArticlesImage2.childImageSharp.fluid}
                  className="articlesImage"
                />
                <Img
                  fluid={data.ArticlesImageMobile2.childImageSharp.fluid}
                  className="articlesImageMobile"
                />
                <ArticlesItemInnerWrapper>
                  <p className="person">Martyna Filipiak, 16.04.2021</p>
                  <p className="title three">
                    Jak budować postawę
                    <br /> odpowiedzialności
                    <br /> finansowej?
                  </p>
                  <ArticlesLinkButtonWrapper>
                    <ArticlesLinkButton to="/strefa-rodzica/jak-budowac-postawe-odpowiedzialnosci-finansowej">
                      czytaj całość
                    </ArticlesLinkButton>
                  </ArticlesLinkButtonWrapper>
                </ArticlesItemInnerWrapper>
              </ArticlesItemWrapper>
            </Row>
          </Col>
          <ArticlesItemWrapper xs={12} lg={6}>
            <Img
              fluid={data.ArticlesImage3.childImageSharp.fluid}
              className="articlesImage"
            />
            <Img
              fluid={data.ArticlesImageMobile3.childImageSharp.fluid}
              className="articlesImageMobile"
            />
            <ArticlesItemInnerWrapper>
              <p className="person">Łukasz Grygiel, 16.04.2021</p>
              <p className="title four">
                Jak wdrażać dzieci
                <br />w{'\u00A0'}prowadzenie dorosłego
                <br />
                domowego budżetu?
              </p>
              <ArticlesLinkButtonWrapper>
                <ArticlesLinkButton to="/strefa-rodzica/jak-wdrazac-dzieci-w-prowadzenie-doroslego-domowego-budzetu">
                  czytaj całość
                </ArticlesLinkButton>
              </ArticlesLinkButtonWrapper>
            </ArticlesItemInnerWrapper>
          </ArticlesItemWrapper>
        </Row>
      </ArticlesContainer>
    </ArticlesWrapper>
  )
}

export default Articles
